<mat-card>
  <mat-card-header>
    <h1>Contact Event</h1>
  </mat-card-header>
  @if(!formGroup){
  <div class="alert alert-danger" role="alert">
    loading...
  </div>
  }
  @else{
  <mat-card-content>
    <form [formGroup]="formGroup" class="form-fields">
      <div class="col-3">
        <label for="creationDate-input">Contact Date:</label>
        <mat-form-field>
          <input matInput
                 id="creationDate-input"
                 formControlName="creationDate"
                 [matDatepicker]="picker">
          <mat-datepicker-toggle matIconSuffix [for]="picker" />
          <mat-datepicker #picker />
          @if(formGroup.get('creationDate')?.errors?.['required']){
          <mat-error>Contact Date is <strong>required</strong></mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-3">
        <label for="visitType-input">Contact Type:</label>
        <mat-form-field>
          <mat-select id="visitType-input" formControlName="visitType">
            @for (option of contactEventOptions.contactTypes; track option) {
            <mat-option [value]="option">{{option}}</mat-option>
            }
          </mat-select>
          @if(formGroup.get('visitType')?.errors?.['required']){
          <mat-error>Contact Type is <strong>required</strong></mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-3">
        <label for="contactReason-input">Contact Reason:</label>
        <mat-form-field>
          <mat-select id="contactReason-input" formControlName="contactReason">
            @for (option of contactEventOptions.reasons; track option) {
            <mat-option [value]="option">{{option}}</mat-option>
            }
          </mat-select>
          @if(formGroup.get('contactReason')?.errors?.['required']){
          <mat-error>Contact Reason is <strong>required</strong></mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-3">
        <label for="startDate-input">Start Time:</label>
        <mat-form-field>
          <input matInput
                 id="startDate-input"
                 formControlName="startDate"
                 [matTimepicker]="startDatepicker">
          <mat-timepicker-toggle matIconSuffix [for]="startDatepicker" />
          <mat-timepicker #startDatepicker />
          @if(formGroup.get('startDate')?.errors?.['required']){
          <mat-error>Start Time is <strong>required</strong></mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-3">
        <label for="endDate-input">End Time:</label>
        <mat-form-field>
          <input matInput
                 id="endDate-input"
                 formControlName="endDate"
                 [matTimepicker]="endDatepicker">
          <mat-timepicker-toggle matIconSuffix [for]="endDatepicker" />
          <mat-timepicker #endDatepicker />
          @if(formGroup.get('endDate')?.errors?.['required']){
          <mat-error>End Time is <strong>required</strong></mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-3">
        <mat-slide-toggle formControlName="wasContactUnsuccessful">
          Contact Unsuccessful
        </mat-slide-toggle>
      </div>
      <div class="col-2">
        <label for="goal-input">Goal:</label>
        <mat-form-field>
          <textarea rows="4" matInput
                    id="goal-input"
                    placeholder="Goal:"
                    formControlName="goal"
                    [attr.aria-describedby]="'goal-input-hint'"
                    [attr.aria-labelledby]="'goal-input-label'">
        </textarea>
          @if(formGroup.get('goal')?.errors?.['required']){
          <mat-error>Contact Date is <strong>required</strong></mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-2">
        <label for="outcome-input">Outcome:</label>
        <mat-form-field>
          <textarea rows="4" matInput
                    id="outcome-input"
                    placeholder="Outcome:"
                    formControlName="outcome"
                    [attr.aria-describedby]="'outcome-input-hint'"
                    [attr.aria-labelledby]="'outcome-input-label'">
          </textarea>
          @if(formGroup.get('outcome')?.errors?.['required']){
          <mat-error>Contact Date is <strong>required</strong></mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-1">
        <dl>
          @for(note of contactEventNotes; track note){
          <dt><b>{{note.authorName}}</b> on <i>{{note.recordCreatedDate | date:'EEE, dd MMM yyyy hh:mm a'}} wrote:</i></dt>
          <dd><cite>{{ note.noteText }}</cite></dd>
          }
        </dl>
        <label for="centralNotes-input">Central Note:</label>
        <mat-form-field>
          <textarea rows="6" matInput
                    id="centralNotes-input"
                    placeholder="Central Note:"
                    formControlName="note"
                    [attr.aria-describedby]="'centralNotes-input-hint'"
                    [attr.aria-labelledby]="'centralNotes-input-label'">
    </textarea>
          @if(formGroup.get('note')?.errors?.['required']){
          <mat-error>Contact Date is <strong>required</strong></mat-error>
          }
        </mat-form-field>
      </div>
    </form>
    <mat-card-actions>
      <button matButton="tonal" (click)="cancel()">Cancel</button>
      <button matButton="filled">Save</button>
    </mat-card-actions>
  </mat-card-content>
  }
</mat-card>

